var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueCtkDateTimePicker',{attrs:{"no-label":"","minute-interval":"10","label":_vm.label,"format":"DD-MM-YYYY HH:mm","formatted":"DD-MM-YYYY HH:mm"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }